import zh from './zh'
import tw from './tw'
import en from './en'
import jp from './jp'

export default {
  zh,
  tw,
  en,
  jp
}



// WEBPACK FOOTER //
// ./src/assets/script/i18n/index.js